import React, { useState, useEffect } from 'react';
import { Dialog, IconButton, Typography, Icon, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './ShareModal.styles';
import { replace } from 'global/lib/lodash';
import { Alert } from '@material-ui/lab';
import clsx from 'clsx';
import { copyToClipboard, addNewLinesToText, checkCanShare } from 'global/utils';
import SnackAlerts from 'global/components/snack-alerts';

export default (props) => {
  const { link } = props;
  const [error, setError] = useState();
  const [alerts, setAlerts] = useState();
  const [text, setText] = useState('');
  const [canShare, setCanShare] = useState(false);

  const classes = useStyles();

  const title = props.title || 'Share Task PDF';

  const handleClose = () => {
    props.onClose();
  };

  const clearAlerts = () => {
    setAlerts();
  };

  const copyLink = () => {
    clearAlerts();
    copyToClipboard(link);
    setAlerts({
      message: 'Link copied to clipboard.',
    });
  };

  const openLink = () => {
    window.open(link, '_blank');
  };

  const copyToEmail = () => {
    //this is all necessary because the ? and & get stripped from the body
    const repl = {
      '\\?': '%3F',
      '\\&': '%26',
    };
    let txt = addNewLinesToText(text, '%0D%0A%0D%0A');
    Object.keys(repl).map((k) => {
      txt = replace(txt, new RegExp(k, 'g'), repl[k]);
    });
    const subject = props.isScorePdf ? `Assessment Score PDF` : title;
    let url = `mailto:user@example.com?subject=${subject}&body=${txt}`;
    window.open(url, '_blank');
  };

  const share = async () => {
    try {
      await navigator.share({ title, url: link });
    } catch (err) {
      console.warn(err);
    }
  };

  useEffect(() => {
    if (props.open) {
      const canShare = checkCanShare();
      setCanShare(canShare);

      const emailText = `You've been assigned a new task, please review the pdf here: `;

      setText(
        props.emailText ||
          `${emailText}
${link}

Thanks,`
      );

      setTimeout(() => {
        if (canShare) {
          try {
            document.getElementById('ShareBtn').click();
          } catch (err) {
            console.warn(err);
          }
        }
      }, 500);
    }
  }, [props.open]);

  return (
    <Dialog className={classes.dialog} disableEscapeKeyDown open={props.open} onClose={handleClose}>
      <div className={classes.container}>
        {error && (
          <Alert
            severity="error"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setError();
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {error}
          </Alert>
        )}

        <IconButton className={classes.closeIcon} onClick={handleClose}>
          <Icon>close</Icon>
        </IconButton>
        <div className={classes.titleRow}>
          <Typography variant="h5" className={classes.subtitle}>
            {title}
          </Typography>
        </div>

        <div className={classes.inputContainer}>
          <div className={classes.buttonContainer}>
            <Button onClick={openLink} variant="outlined" color="secondary" className={classes.button}>
              VIEW PDF
            </Button>

            <Button onClick={copyLink} startIcon={<Icon>filter_none</Icon>} variant="contained" color="secondary" className={classes.button}>
              COPY LINK
            </Button>

            <Button onClick={copyToEmail} startIcon={<Icon>mail</Icon>} variant="contained" color="secondary" className={classes.button}>
              COPY TO EMAIL
            </Button>

            {canShare && (
              <Button onClick={share} startIcon={<Icon>share</Icon>} variant="contained" color="secondary" className={classes.button} id="ShareBtn">
                SHARE
              </Button>
            )}

            <Button onClick={handleClose} variant="contained" startIcon={<Icon>close</Icon>} className={clsx(classes.button, classes.closeBtn)}>
              CLOSE
            </Button>
          </div>
        </div>
      </div>
      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
    </Dialog>
  );
};
